import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import { BModal } from 'bootstrap-vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'Step3SaveTemplateModal',
  props: {
    saveTemplateModal: null
  },
  emits: ['navigateToHome', 'navigateToTemplates'],
  setup(__props: any, { emit }) {

const props = __props as {
    saveTemplateModal: {
        isOpen: boolean;
        title: string;
        productTitle: string;
        productId: string;
    };
};



const getTitle = computed((): string => {
    return props.saveTemplateModal?.title;
});
async function copyToClipboard() {
    const msgToCopy = props.saveTemplateModal.productId;
    if (!msgToCopy) {
        return;
    }
    await navigator.clipboard.writeText(msgToCopy);
}
const productTitle = computed((): string => {
    const fullTitle = props.saveTemplateModal?.productTitle || '';
    if (fullTitle.length <= 58) {
        return fullTitle;
    }

    // Find the last space before the 58th character
    const lastSpaceIndex = fullTitle.lastIndexOf(' ', 57);

    // If no space is found, just truncate at 58 (single long word)
    const truncateIndex = lastSpaceIndex === -1 ? 58 : lastSpaceIndex;

    return fullTitle.slice(0, truncateIndex) + '...';
});

function onNavigateToHomeClick() {
    emit('navigateToHome');
}
function onNavigateToTemplatesClick() {
    emit('navigateToTemplates', props.saveTemplateModal.productId);
}

return { __sfc: true,props, emit, getTitle, copyToClipboard, productTitle, onNavigateToHomeClick, onNavigateToTemplatesClick, BModal }
}

})